module.exports = __webpack_public_path__ + "static/media/Group 1072.7209c2f8.svg";